import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
// import StayConnected from '../../Components/StayConnectedSection';

// import RightArrow from '../../assets/images/right-arrow.png';

export default function DevelopmentDesignServices() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='service-page'>
      <Helmet>
        <title>Starlife: Development Services</title>
        <meta
          name='description'
          content='From land to landmark, we bring bold ideas to life with discipline and design excellence.'
        />
        <meta
          name='keywords'
          content='Development Services, Real Estate Development, Pre-Development Planning, Smart & Sustainable Building'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          Development Services | Transforming vision into value
        </h2>
        <p className='service-page-text'>
          We offer full service real estate development, guiding projects from
          site selection to completion with precision and purpose. Our expertise
          lays the foundation for long term success through strategic planning,
          design collaboration, and community integration.
        </p>
      </div>
      <div className='our-services-section'>
        <h2 className='section-title'>Services</h2>
        <div className='service-list'>
          <Link
            // to={ROUTE_NAMES.REALESTATEDEVELOPMENT}
            className='service-block green-block'
          >
            <h3>End to end real estate development management</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.PREDEVELOPMENTPLANNING}
            className='service-block'
          >
            <h3>Site selection, feasibility studies and due diligence</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.DESIGNBUILD}
            className='service-block green-block'
          >
            <h3>Design coordination with architectural partners</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
          <Link
            // to={ROUTE_NAMES.SMARTSUSTAINABLE}
            className='service-block'
          >
            <h3>Project entitlements and strategic acquisitions</h3>
            {/* <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button> */}
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      {/* <StayConnected /> */}
    </div>
  );
}
